import React, { memo, useMemo } from "react";
import { useDistributionGroups } from "modules/providers/distribution-groups-provider";
import { Highlight, Text } from "@chakra-ui/react";
import colors from "app/colors";
import DistributionGroupTooltip from "../distribution-group-tooltip";
import { getDistributionGroupMention } from "modules/utils/Functions";
import useQueryString from "modules/hooks/use-query-string";

interface IProps {
  id: string;
  highlight?: boolean;
}

const DistributionGroupMention = ({ id, highlight = true }: IProps) => {
  const { distributionGroupsById } = useDistributionGroups();
  const { qsMessageHighlights } = useQueryString();

  const distributionGroup = useMemo(
    () => distributionGroupsById[id],
    [distributionGroupsById, id],
  );

  const highlightQuery = highlight ? qsMessageHighlights : "";

  if (!distributionGroup) return null;

  if (!distributionGroup.active) {
    return (
      <Text
        fontWeight={400}
        color={colors.blackSecondary}
        as="span"
        fontStyle="italic"
      >
        {getDistributionGroupMention(distributionGroup)}
      </Text>
    );
  }

  return (
    <DistributionGroupTooltip id={id}>
      <Text fontWeight="semibold" color={colors.blue} as="span">
        <Highlight query={highlightQuery} styles={{ bg: colors.yellow }}>
          {getDistributionGroupMention(distributionGroup)}
        </Highlight>
      </Text>
    </DistributionGroupTooltip>
  );
};

export default memo(DistributionGroupMention);
